import Box from '@zenbusiness/zui/Box';
import DialogActions from '@zenbusiness/zui/DialogActions';
import Divider from '@zenbusiness/zui/Divider';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const SummaryCard = superstyled({
  tag: Box,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'SummaryCard',
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '1rem',
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
  }),
});

export const SummaryDivider = superstyled({
  tag: Divider,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'SummaryDivider',
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
  }),
});

export const SectionLabel = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'SectionLabel',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(0.5),
  }),
});

export const RenewNoteGridItem = superstyled({
  tag: Grid,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'RenewNoteGridItem',
  styles: ({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
    },
  }),
});

export const CreditAmountGridItem = superstyled({
  tag: Grid,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'CreditAmountGridItem',
  styles: {
    textAlign: 'right',
  },
});

export const TotalDueCard = superstyled({
  tag: Box,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'TotalDueCard',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: '1rem',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  }),
});

export const ConsentStack = superstyled({
  tag: Stack,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'ConsentStack',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2),
  }),
});

export const ConsentFormControlLabel = superstyled({
  tag: FormControlLabel,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'ConsentFormControlLabel',
  styles: {
    marginLeft: 0,
  },
});

export const ReviewDialogActions = superstyled({
  tag: DialogActions,
  name: 'ChangeBillingIntervalAnnualReview',
  slot: 'ReviewDialogActions',
  styles: ({ theme }) => ({
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});
